<template>
  <div>
    <StatisticUserTableDialog ref="statisticUserDialog"></StatisticUserTableDialog>
    <v-card>
        <p class="pt-3 pl-3 title">Statistic Users</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="countryObjectIntoArray"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
              medium
              @click="$refs.statisticUserDialog.openDialog(item)"
              color="error"
            >
              fas fa-book
            </v-icon>
          </template>
        </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StatisticUserTableDialog from "@/pages/admin/components/statistic/users/dialog/statisticUserTableDialog"
export default {
  components:{
    StatisticUserTableDialog
  },
  data(){
    return {
      formstatus:"",
      listcountries:[],
      users: [],
      userData:[],
      datoer:[
        1, 2, 3
      ],
      headers:[
        { text: 'Country', value: 'country', align: 'center' },
        { text: 'Amount of Users', value: 'users', align: 'center' },
        { text: 'New Users (24h)', value: 'newUsersDay', align: 'center' },
        { text: 'New Users (week)', value: 'newUsersWeek', align: 'center' },
        { text: 'New Users (month)', value: 'newUsersMonth', align: 'center' },
        { text: 'New Users (year)', value: 'newUsersYear', align: 'center' },
        { text: 'User Development', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  methods: {
    /*
      #0
      Get these functions from store.js
    */
    ...mapActions([
      "GET_ALL_USER_DATA"
    ]),

    /*
      #1
      Get the data made from the function made in store.js  (GET_ALL_USER_DATA)
      Then use a spread operator to run through, and get Created key, and manipulate it into something we wish to use later.
    */
    getAllUserData() {
      this.GET_ALL_USER_DATA().then(response => {
        response = response.map(el => {
          return {
            ...el,
           CreatedDays: this.$moment().diff(this.$moment(el.Created), 'days'),
          }
        })
        this.userData = response;
      });
    }
  },
  computed:{
    /*
      #2
      Creating a new object, to use in the data table
      We use the filter function below (checkNewUsers)   aka //#3
      Then we create a variable, and assign it the value we filtered out below
    */
    countryObjectIntoArray(){
      if (this.checkNewUsers.countries ) {
        return Object.keys(this.checkNewUsers.countries).map((key, index) => {
          let _return = {
            country: key,
            users: this.checkNewUsers.countries[key].total,
            newUsersDay:  this.checkNewUsers.countries[key].thisDay,
            newUsersWeek: this.checkNewUsers.countries[key].thisWeek,
            newUsersMonth:  this.checkNewUsers.countries[key].thisMonth,
            newUsersYear:  this.checkNewUsers.countries[key].thisYear,
            // NewUserYearGraph: this.checkNewUsers.countries[key].totalUserdata.map(el => this.$moment().diff(this.$moment(el.Created), 'months')).sort((a,b) => {return a < b ? -1 : a > b ? 1 : 0}),
            NewUserYearGraph: [1,1,1,1,5,5,5,5,6,7,8,9],
            user:  this.checkNewUsers.countries[key].totalUserdata,
            test: this.checkNewUsers.countries[key].datoer
          }
          let newuseryeargraph = new Array(12);
          for (var i = 0; i < newuseryeargraph.length; i++) {
            newuseryeargraph[i] = this.checkNewUsers.countries[key].totalUserdata.filter(el => this.$moment().diff(this.$moment(el.Created), 'months') == (newuseryeargraph.length - i - 1)).length;
          }
          _return.NewUserYearGraph = newuseryeargraph;
          return _return;
        });
      } else {
        return [];
      }
    },
    /*
      #3 - Filter function
      Function to check the users. Total users and new users created within a time window
        - Mapping over and getting all the created values
    */
    checkNewUsers(){
      /*
        Filter for TOTAL users within each country
        Using CreatedDays which we get from the main GET function (getAllUserData)  aka //#1
      */
      // let tmpUser = this.userData[2];
      let thisDay = this.userData.filter(user => user.CreatedDays === 0).length;
      let thisWeek = this.userData.filter(user => user.CreatedDays < 7).length;
      let thisMonth = this.userData.filter(user => user.CreatedDays < 31).length;
      let thisYear = this.userData.filter(user => user.CreatedDays < 365).length;
      let seeAllThisYear = this.userData.filter(user => user.CreatedDays < 365);
      let countries = {};
      /*
        Filter for the specific country.
        Running x2 filter.   
          - 1. country
          - 2. Created aka CreatedDays to filter on its value.
            - We created this key in the initial function (getAllUserData)  aka //#1
      */ 
      this.userData.map(user => user.Country).forEach(country => {
        if (!countries.hasOwnProperty(country)) {
          let thisDay = this.userData.filter(user => user.Country === country).filter(user => user.CreatedDays === 0).length;
          let thisWeek = this.userData.filter(user => user.Country === country).filter(user => user.CreatedDays < 7).length;
          let thisMonth = this.userData.filter(user => user.Country === country).filter(user => user.CreatedDays < 31).length;
          let thisYear = this.userData.filter(user => user.Country === country).filter(user => user.CreatedDays < 365).length;
          let total = this.userData.filter(user => user.Country === country).length;
          let totalUserdata = this.userData.filter(user => user.Country === country);
          // Where we put all these variables into countries,  which again goes into the return object below
          countries[country] = {thisDay, thisWeek, thisMonth, thisYear, total, totalUserdata }
        }
      })
      // The values we wish to return (use outside this function)
      return {thisDay, thisWeek, thisMonth, thisYear, countries};
    }
  },
  // When loading page, run the functions within mounted.
  mounted() {
    this.getAllUserData();
  }
}
</script>